// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"hR-z","inlineTitle":"iR-z","sponsoredAdsWrapper":"jR-z","marketplaceRecosWrapper":"kR-z"};